import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doPut } from "../../../config/fetchWrapper";
import { urls } from "../../endPoints";

export const editEntities = createAsyncThunk(
  "editEntities",
  async (arg, { rejectWithValue }) => {
    try {
      const response = await doPut(urls?.editEntities, arg);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteEntities = createAsyncThunk(
  "deleteEntities",
  async (arg, { rejectWithValue }) => {
    try {
      const response = await doPut(urls?.deleteEntities, arg);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const editEntitiesSlice = createSlice({
  name: "editEntities",
  initialState: {
    isLoading: false,
    success: false,
    error: null,
    data: false,
  },
  reducers: {
    editEntitiesReset: () => {
      return {
        isLoading: false,
        success: false,
        error: null,
        data: false,
      };
    },
  },
  extraReducers: {
    [editEntities.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.success = true;
      state.error = null;
      state.data = payload;
    },
    [editEntities.pending]: (state) => {
      state.isLoading = true;
      state.error = null;
      state.success = false;
    },
    [editEntities.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
      state.data = false;
    },
  },
});

export const deleteEntitiesSlice = createSlice({
  name: "deleteEntities",
  initialState: {
    isLoading: false,
    success: false,
    error: null,
    data: false,
  },
  reducers: {
    deleteEntitiesReset: () => {
      return {
        isLoading: false,
        success: false,
        error: null,
        data: false,
      };
    },
  },
  extraReducers: {
    [deleteEntities.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.success = true;
      state.error = null;
      state.data = payload;
    },
    [deleteEntities.pending]: (state) => {
      state.isLoading = true;
      state.error = null;
      state.success = false;
    },
    [deleteEntities.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
      state.data = false;
    },
  },
});

export const { editEntitiesReset } = editEntitiesSlice.actions;
export const { deleteEntitiesReset } = deleteEntitiesSlice.actions;
